export default __webpack_public_path__ + "static/media/benefit-2.2fe3b0ca.png";